import React from 'react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function Familiar() {
  return <SectionShell data-id="element-133" data-mp="1xs2fhvh3aziw">
      <SectionTitle title="Does this sound familiar?" subtitle="If you answered YES to even one of these, the TRT Decision Deck™ was designed for you." data-id="element-134" data-mp="1xsly7eekdrxz" />

      <ul className="grid gap-3 sm:grid-cols-2" data-id="element-135" data-mp="26rpiumtdqfel">
        {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-xl border border-sky-400/15 bg-navy-800 p-4" data-id="element-136" data-mp="22qx8trcoo6h9">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-137" data-mp="2gp3odrdrljs4">
              {point.emoji}
            </span>
            <p className="text-sm leading-relaxed text-sky-100/80" data-id="element-138" data-mp="2bs4sp4egd4rt">{point.text}</p>
          </li>)}
      </ul>

      <div className="mt-8 rounded-xl border-l-4 border-sky-400 bg-navy-950 p-5" data-id="element-139" data-mp="me8emlqufynr">
        <p className="text-sm leading-relaxed text-sky-100/80" data-id="element-140" data-mp="hf578une5gcm">
          And it shouldn’t have to be that way. Because the problem isn’t always a lack of
          information.{' '}
          <strong className="text-white" data-id="element-141" data-mp="dzwuxavh26r3">
            Sometimes the problem is not having a fast way to navigate the information you already
            have.
          </strong>
        </p>
      </div>

      <div className="mt-8" data-id="element-142" data-mp="mt9v8xvv8an7">
        <CTAButton label="Get the visual system" subline="Instant digital access · 7-day guarantee" data-id="element-143" data-mp="mtjqazvrp7zr" />
      </div>
    </SectionShell>;
}